module.exports = __webpack_public_path__ + "static/media/blogthumb3.4a8c2141.jpg";